import clsx from "clsx";

interface UnreadBadgeProps {
  count: number;
  size?: "sm" | "md";
  className?: string;
  "aria-label"?: string;
}

export function UnreadBadge({
  count,
  size = "sm",
  className,
  ...rest
}: UnreadBadgeProps) {
  if (count <= 0) return null;

  const base =
    "inline-flex items-center justify-center rounded-full bg-sky-600 font-semibold text-white shadow-sm";
  const sizes =
    size === "md"
      ? "px-2.5 py-1 text-xs min-w-[28px]"
      : "px-2 py-0.5 text-[11px] min-w-[24px]";

  return (
    <span className={clsx(base, sizes, className)} {...rest}>
      {count > 99 ? "99+" : count}
    </span>
  );
}
